export enum ArchivedHeatActions {
  SET_START_DATE = 'SET_START_DATE',
  SET_END_DATE = 'SET_END_DATE',
  SET_PAGE = 'SET_PAGE',
  SET_SIZE = 'SET_SIZE',
  RESET_DATE = 'RESET_DATE',
}
